module.exports = __webpack_public_path__ + "img/jason.1326561.webp";